// extracted by mini-css-extract-plugin
module.exports = {"trustedBy":"trusted-by_trustedBy__TOncI","heading":"trusted-by_heading__5rgD1"};